module.exports = {
      id: "b9f01fdeffb261c2e1c450780c69195ckitchenEquipment-partly-fitted-kitchen-with-appliances.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#b9f01fdeffb261c2e1c450780c69195ckitchenEquipment-partly-fitted-kitchen-with-appliances.svg",
      toString: function () {
        return this.url;
      }
    }